import { createSlice } from '@reduxjs/toolkit';

const initialState = {};

const appointmentSlice = createSlice({
    name: 'appointment',
    initialState,
    reducers: {
        setAppointment: (state, action) => {
            return action.payload;
        },
        removeAppointment: () => {
            return initialState;
        },
    },
});

export const { setAppointment, removeAppointment } = appointmentSlice.actions;
export default appointmentSlice.reducer;